{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-24T03:55:14.311Z","source":"place-details"}